import { getName } from "country-list";
import UserDefaultLogo from "../../../assets/svg/user-avatar.svg";
import {
  ISchoolStudentsBackEndModel,
  ISchoolStudentsFrontEndModel,
  StudentStatus,
} from "../types";

function parser(schoolStudent: ISchoolStudentsBackEndModel) {
  const schoolStudentData: ISchoolStudentsFrontEndModel = {
    id: schoolStudent.id,
    name: schoolStudent.name,
    status:
      schoolStudent.studentStatus === null
        ? StudentStatus.DEFAULT
        : schoolStudent.studentStatus,
    photo: schoolStudent.photo ? schoolStudent.photo.preview : UserDefaultLogo,
    hasNewMessage: false, // todo replace hasNewMessage
    country: getName(schoolStudent.studentProfile.country)!,
  };

  return schoolStudentData;
}

export function parseToSchoolStudentsFrontEndModel(response) {
  response.data = response.data?.map((student) => parser(student));

  return response;
}
